angular.module('bmsApp.directives')
	.directive('bms1Href', function() {
		return {
			restrict: 'A',
			require: [],
			link: function($scope, iElement, iAttrs) {
                iElement.attr('href', $scope.href + '/brand/' + iAttrs.bms1Href);

				iAttrs.$observe('bms1Href',function(newValue){
					iElement.attr('href', $scope.href + '/brand/' + newValue);
				});

			},
		}
});
